// auth/auth.mock.service.ts
import { Observable, of } from 'rxjs';
import { IAuthService } from './auth.types';
import { IdTokenClaims, User } from 'oidc-client-ts';
import { UrlTree } from '@angular/router';

export class MockAuthService implements IAuthService {
    currentUser = {
        profile: {
            email : 'mock-user@quantium.pe',
            preferred_username :   'mock-user@quantium.pe',
            name : 'mock-user'            
        }
    };

    companyUri: string = '';
    identityServerEndpoint: string = '';
    isReady: boolean = true;
    newIdentityServerEndpoint: string | null = '';

    initUserManager = (): void => { };
    registerIdentityServerEndpoint = (_companyUri: string): Promise<UrlTree | void> => new Promise((resolve) => resolve());
    tryGetUserInStorage = (): Promise<User | null> => new Promise((resolve, _) => resolve(this.getUser()));

    signIn = (_redirectUrl?: string): void => { };
    signOut = (): void => { };
    signinSilent = (): Promise<User | null> => new Promise((resolve, _) => resolve(this.getUser()));
    fallback = (): void => { };
    signinRedirectCallback = (url?: string): Promise<string> => new Promise((resolve, _) => resolve(''));
    signinSilentCallback = (): Promise<void> => new Promise((resolve, _) => resolve());

    isAccessTokenExpiring = (): boolean => false;
    canAccessThirdPartyCookies = (): Promise<boolean> => new Promise((resolve, _) => resolve(false));
    isUserInStorageSameToAuth = (): Promise<boolean> => new Promise((resolve, _) => resolve(true));
    hasAccessToCompanyUri = (): Observable<boolean> => of(true);
    needSignInToClientUri = (): Observable<boolean> => of(false);
    checkCompanyUri = (_companyUri: string): Observable<boolean> => of(true);
    canSwitchRole = (): boolean => true;
    hasMultipleClients = (): boolean => false;

    getAccessToken = () => 'dev-token';
    getUser = (): User => new User({
        id_token: '',
        session_state: '',
        access_token: '',
        refresh_token: '',
        token_type: '',
        scope: '',
        profile: {} as IdTokenClaims,
        expires_at: undefined,
        userState: null
    });

    getAuthorizationToken = (): string => this.getAccessToken();

    listenToUserSessionChangedEvent = (): void => { };
    listenToSignedOutEvent = (): void => { };

}
